import { language, useSetLanguage } from "@/hooks/languageHooks";
import { faEarthEurope } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { DropdownMenuGroup, DropdownMenuItem, DropdownMenuLabel } from "frontend-components";
import { useTranslation } from "react-i18next";

export const LanguageSelector = () => {
    const { t } = useTranslation();
    const { handleLanguageChange, currentLanguage } = useSetLanguage();

    return (
        <DropdownMenuGroup className="flex flex-row items-center gap-2 px-2">
            <DropdownMenuLabel className="px-0">
                <FontAwesomeIcon icon={faEarthEurope} />
            </DropdownMenuLabel>
            <DropdownMenuItem
                onClick={() => {
                    handleLanguageChange(language.english);
                }}
                className={`px-0 text-md cursor-pointer focus:bg-inherit focus:underline ${currentLanguage === "en" ? "font-semibold underline" : ""}`}
            >
                {t("common.english")}
            </DropdownMenuItem>
            <span className="text-muted-foreground text-sm">/</span>
            <DropdownMenuItem
                onClick={() => {
                    handleLanguageChange(language.norwegian);
                }}
                className={`px-0 text-md cursor-pointer focus:bg-inherit focus:underline ${currentLanguage === "nb" ? "font-semibold underline" : ""}`}
            >
                {t("common.norwegian")}
            </DropdownMenuItem>
        </DropdownMenuGroup>
    );
};
